module.exports = __webpack_public_path__ + "static/media/bombs.e056fe51.jpg";